import { type Epik, type EpikEvent, TransactionStatus } from '@raisenow/epik';
import { Observable, takeWhile } from 'rxjs';

interface EppPaymentStatusPoll {
  paymentId: string;
  paymentStatus: TransactionStatus;
}

/**
 * Polls the transaction status using the given `epik` instance.
 *
 * @param epik
 * @returns
 * An `Observable` that emits with the transaction status data.
 */
function transactionStatusPoll(epik: Epik): Observable<EppPaymentStatusPoll> {
  return new Observable((subscriber) => {
    const unsubscribe = epik.events.eppPaymentStatusPoll.subscribe((e) => {
      const { data } = e as EpikEvent<EppPaymentStatusPoll>;
      subscriber.next(data);
    });

    return () => {
      unsubscribe();
      // Manually stop polling
      epik.eppPaymentStatusPoll.stop();
    };
  });
}

/**
 * Polls the transaction info using the given `epik` instance
 *
 * @param epik
 * @returns
 * An `Observable` that emits the transaction info.
 */
export function pollTransactionInfo(epik: Epik) {
  return transactionStatusPoll(epik).pipe(
    // Stop polling, once the status is no longer 'pending'
    takeWhile((info) => TransactionStatus.PENDING === info.paymentStatus, true),
  );
}
